import React, { useState, useEffect } from 'react';
import { adminService } from '../services/adminService.js';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';

function Schedules() {
  const [schedules, setSchedules] = useState([]);
  const [stats, setStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, content: '' });
  const [hovered, setHovered] = useState({});
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 20, totalPages: 0 });
  const [filters, setFilters] = useState({ status: '', today: false, page: 1 });

  useEffect(() => {
    loadData();
  }, [filters.page, filters.status, filters.today]);

  const loadData = async () => {
    try {
      setLoading(true);
      setStatsLoading(true);
      const params = { page: filters.page, limit: 20 };
      if (filters.status) params.status = filters.status;
      if (filters.today) params.today = true;

      const [schedulesResult, statsResult] = await Promise.all([
        adminService.getSchedules(params),
        adminService.getSchedulesStats(),
      ]);
      setSchedules(schedulesResult.schedules || []);
      setPagination(schedulesResult.pagination || { total: 0, page: 1, limit: 20, totalPages: 0 });
      setStats(statsResult);
    } catch (err) {
      toast.error('Erro ao carregar agendamentos');
    } finally {
      setLoading(false);
      setStatsLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const map = {
      pending: { label: 'Pendente', class: 'badge-warning' },
      confirmed: { label: 'Confirmado', class: 'badge-info' },
      done: { label: 'Concluído', class: 'badge-success' },
      canceled: { label: 'Cancelado', class: 'badge-danger' },
      noshow: { label: 'Não compareceu', class: 'badge-dark' },
      rejected: { label: 'Rejeitado', class: 'badge-dark' },
    };
    if (!status) return { label: '-', class: 'badge-default' };
    return map[String(status).toLowerCase()] || { label: status, class: 'badge-default' };
  };

  const getStatusColor = (status) => {
    const s = String(status || '').toLowerCase();
    switch (s) {
      case 'pending':
        return 'var(--chart-amber)';
      case 'confirmed':
        return 'var(--chart-blue)';
      case 'completed':
      case 'done':
        return 'var(--chart-green)';
      case 'canceled':
      case 'cancelled':
        return 'var(--chart-red)';
      case 'noshow':
      case 'no-show':
        return 'var(--chart-gray)';
      case 'rejected':
        return 'var(--chart-gray)';
      default:
        return 'var(--chart-violet)';
    }
  };

  

  return (
    <div className="admin-page">
      {statsLoading ? (
        <div className="stats-grid stats-grid-4">
          {[1,2,3,4].map(i => <div key={i} className="shimmer shimmer-card"></div>)}
        </div>
      ) : (
        stats && (
          <div className="stats-grid stats-grid-4">
          <div className="stat-card">
            <div className="stat-card-content">
              <div className="stat-card-info">
                <span className="stat-label">Total</span>
                <span className="stat-value">{stats.totalSchedules?.toLocaleString('pt-BR') || '0'}</span>
              </div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-card-content">
              <div className="stat-card-info">
                <span className="stat-label">Hoje</span>
                <span className="stat-value">{stats.schedulesToday || 0}</span>
              </div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-card-content">
              <div className="stat-card-info">
                <span className="stat-label">Esta Semana</span>
                <span className="stat-value">{stats.schedulesThisWeek || 0}</span>
              </div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-card-content">
              <div className="stat-card-info">
                <span className="stat-label">Este Mês</span>
                <span className="stat-value">{stats.schedulesThisMonth || 0}</span>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="admin-filters">
        <div
          className="filter-group"
          style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between' }}
        >
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <label style={{ fontSize: 13, color: '#374151' }}>Status</label>
              <select
                value={filters.status}
                onChange={(e) => setFilters(f => ({ ...f, status: e.target.value, page: 1 }))}
                className="filter-control"
              >
                <option value="">Todos os Status</option>
                <option value="PENDING">Pendente</option>
                <option value="CONFIRMED">Confirmado</option>
                <option value="DONE">Concluído</option>
                <option value="CANCELED">Cancelado</option>
              </select>
          </div>

          <label className="checkbox-filter" style={{ display: 'flex', alignItems: 'center', gap: 8, height: 36, padding: '8px', boxSizing: 'border-box' }}>
            <input type="checkbox" checked={filters.today} onChange={(e) => setFilters(f => ({ ...f, today: e.target.checked, page: 1 }))} />
            <span>Apenas hoje</span>
          </label>
        </div>
      </div>

      <div className="admin-table-card">
        <div className="table-header">
          <h3>Agendamentos ({pagination.total})</h3>
        </div>
        {loading ? (
          <div className="table-loading">
            {[1,2,3,4,5].map(i => <div key={i} className="shimmer shimmer-row"></div>)}
          </div>
        ) : (
          <div className="table-responsive">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Data/Hora</th>
                  <th>Usuário</th>
                  <th>Pet</th>
                  <th>Negócio</th>
                  <th>Serviço</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {schedules.length === 0 ? (
                  <tr><td colSpan="6" className="empty-table">Nenhum agendamento encontrado</td></tr>
                ) : schedules.map(schedule => {
                  const badge = getStatusBadge(schedule.status);
                  return (
                    <tr key={schedule.id}>
                      <td>{schedule.dateTime ? dayjs(schedule.dateTime).format('DD/MM/YYYY') : '-'} {schedule.dateTime ? dayjs(schedule.dateTime).format('HH:mm') : ''}</td>
                      <td className="td-name">{schedule.user?.name || schedule.userName || '-'}</td>
                      <td>{schedule.pet?.name || schedule.petName || '-'}</td>
                      <td>{schedule.entity?.name || schedule.entityName || '-'}</td>
                      <td>{schedule.serviceName || schedule.Service?.name || '-'}</td>
                      <td><span className={`badge ${badge.class}`}>{badge.label}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {pagination.totalPages > 1 && (
          <div className="table-pagination">
            <button className="btn btn-sm" disabled={filters.page === 1} onClick={() => setFilters(f => ({ ...f, page: f.page - 1 }))}>Anterior</button>
            <span className="pagination-info">Página {pagination.page} de {pagination.totalPages}</span>
            <button className="btn btn-sm" disabled={filters.page >= pagination.totalPages} onClick={() => setFilters(f => ({ ...f, page: f.page + 1 }))}>Próxima</button>
          </div>
        )}
      </div>

      {stats && (
        <div className="charts-grid">
          {stats.schedulesByStatus && stats.schedulesByStatus.length > 0 && (
            <div className="chart-card">
              <div className="chart-header"><h3>Por Status</h3></div>
              <div className="chart-body">
                {(() => {
                  const items = stats.schedulesByStatus;
                  const total = items.reduce((s, t) => s + (t.count || 0), 0) || 0;

                  const polarToCartesian = (cx, cy, r, angleInDegrees) => {
                    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
                    return {
                      x: cx + (r * Math.cos(angleInRadians)),
                      y: cy + (r * Math.sin(angleInRadians))
                    };
                  };

                  const describeArc = (cx, cy, r, startAngle, endAngle) => {
                    const start = polarToCartesian(cx, cy, r, endAngle);
                    const end = polarToCartesian(cx, cy, r, startAngle);
                    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
                    return [`M ${cx} ${cy}`, `L ${start.x} ${start.y}`, `A ${r} ${r} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`, 'Z'].join(' ');
                  };

                  let acc = 0;
                  const cx = 90, cy = 90, r = 70;

                  const slices = items.map((item, i) => {
                    const value = item.count || 0;
                    const angle = total > 0 ? (value / total) * 360 : 0;
                    const startAngle = acc;
                    const endAngle = acc + angle;
                    const path = describeArc(cx, cy, r, startAngle, endAngle);
                    const pct = total > 0 ? ((value / total) * 100).toFixed(1) : '0.0';
                    const slice = { path, startAngle, endAngle, pct, value, item, color: getStatusColor(item.status), index: i };
                    acc = endAngle;
                    return slice;
                  });

                  return (
                    <div className="pie-chart-wrap" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                      <svg width="180" height="180" viewBox="0 0 180 180" style={{ flex: '0 0 180px' }}>
                        {slices.map((s) => (
                          <path key={s.index}
                            d={s.path}
                            fill={s.color}
                            opacity={(hovered.schedulesByStatus == null) || hovered.schedulesByStatus === s.index ? 1 : 0.28}
                            onMouseEnter={(e) => { setHovered(h => ({ ...h, schedulesByStatus: s.index })); setTooltip({ visible: true, x: e.clientX + 12, y: e.clientY + 12, content: `${s.value} (${s.pct}%)` }); }}
                            onMouseMove={(e) => setTooltip(t => ({ ...t, x: e.clientX + 12, y: e.clientY + 12 }))}
                            onMouseLeave={() => { setHovered(h => ({ ...h, schedulesByStatus: null })); setTooltip({ visible: false, x: 0, y: 0, content: '' }); }}
                          />
                        ))}
                        <circle cx={cx} cy={cy} r={r - 28} fill="#fff" />
                      </svg>

                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          {items.map((item, i) => {
                            const pct = total > 0 ? ((item.count / total) * 100).toFixed(1) : '0.0';
                            return (
                              <div key={i} className="distribution-item" onMouseEnter={(e) => { setHovered(h => ({ ...h, schedulesByStatus: i })); setTooltip({ visible: true, x: e.clientX + 12, y: e.clientY + 12, content: `${item.count} (${pct}%)` }); }} onMouseMove={(e) => setTooltip(t => ({ ...t, x: e.clientX + 12, y: e.clientY + 12 }))} onMouseLeave={() => { setHovered(h => ({ ...h, schedulesByStatus: null })); setTooltip({ visible: false, x: 0, y: 0, content: '' }); }} style={{ display: 'flex', alignItems: 'center', gap: '12px', opacity: (hovered.schedulesByStatus == null) || hovered.schedulesByStatus === i ? 1 : 0.28 }}>
                                <div className="distribution-color" style={{ background: getStatusColor(item.status) }}></div>
                                <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', gap: '8px', alignItems: 'center' }}>
                                  <span className="distribution-name">{getStatusBadge(item.status).label}</span>
                                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                    <span className="distribution-pct">{pct}%</span>
                                    <span className="distribution-count">{item.count}</span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          )}
          {stats.schedulesByWeekday && stats.schedulesByWeekday.length > 0 && (
            <div className="chart-card">
              <div className="chart-header"><h3>Por Dia da Semana</h3></div>
              <div className="chart-body">
                <div className="simple-chart">
                  {stats.schedulesByWeekday.map((item, i) => (
                    <div key={i} className="chart-bar-group" onMouseEnter={(e) => { setHovered(h => ({ ...h, schedulesByWeekday: i })); setTooltip({ visible: true, x: e.clientX + 12, y: e.clientY + 12, content: `${item.count}` }); }} onMouseMove={(e) => setTooltip(t => ({ ...t, x: e.clientX + 12, y: e.clientY + 12 }))} onMouseLeave={() => { setHovered(h => ({ ...h, schedulesByWeekday: null })); setTooltip({ visible: false, x: 0, y: 0, content: '' }); }} style={{ opacity: (hovered.schedulesByWeekday == null) || hovered.schedulesByWeekday === i ? 1 : 0.28 }}>
                      <div className="chart-bar" style={{ height: `${Math.max((item.count / Math.max(...stats.schedulesByWeekday.map(d => d.count), 1)) * 200, 4)}px`, background: 'var(--chart-primary)' }}></div>
                      <span className="chart-bar-label">{item.day || item.weekday}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {tooltip.visible && (
        <div className="cursor-tooltip" style={{ left: tooltip.x + 'px', top: tooltip.y + 'px' }}>{tooltip.content}</div>
      )}
    </div>
  );
}

export default Schedules;